// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import PasswordVisibilityController from './password_visibility_controller';
application.register('password-visibility', PasswordVisibilityController);

import ChoiceSelectController from './choice_select_controller';
application.register('choice-select', ChoiceSelectController);

import DialogController from './dialog_controller';
application.register('dialog', DialogController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import ButtonSpinnerController from './button_spinner_controller';
application.register('button-spinner', ButtonSpinnerController);

import TabsController from './tabs_controller';
application.register('tabs', TabsController);

import AdminChartsController from './admin/charts_controller';
application.register('admin--charts', AdminChartsController);

import DateFilterController from './date_filter_controller';
application.register('date-filter', DateFilterController);

import SearchFormController from './search_form_controller';
application.register('search-form', SearchFormController);

import QrCodeModalController from './qr_code_modal_controller';
application.register('qr-code-modal', QrCodeModalController);

import QrCodeDownloadController from './qr_code_download_controller';
application.register('qr-code-download', QrCodeDownloadController);

import QrCodeAnalyticsController from './qr_code_analytics_controller';
application.register('qr-code-analytics', QrCodeAnalyticsController);

import QrCodeCreateController from './qr_code/create_controller';
application.register('qr-code--create', QrCodeCreateController);
